import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const ImgContainerViews: {
  [key: string]: FlattenSimpleInterpolation;
} = {
  mobile: css`
    margin-bottom: 20px;

    img {
      width: 300px;
    }
  `,
  tablet: css`
    img {
      width: 400px;
    }
  `,
  tabletLandscape: css`
    img {
      width: 400px;
    }
  `,
  browser: css`
    display: flex;
    justify-content: center;
    img {
      width: 450px;
    }
  `,
};

export const ImgContainer = styled.div`
  margin: auto auto 40px;

  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return ImgContainerViews["mobile"];
      case "tablet":
        return props.isLandscape
          ? ImgContainerViews["tabletLandscape"]
          : ImgContainerViews["tablet"];

      case "browser":
        return ImgContainerViews["browser"];
    }
  }}
`;
